import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Genetic Engineering Foundations & Molecular Biology Basics",
    description:
      "Genetic Engineering, Its role in modern science, DNA RNA proteins & gene expression overview, Central Dogma: Replication → Transcription → Translation, Chromosomes genes & genetic variations, Real-world applications in medicine agriculture & research",
  },
  {
    title: "DNA Manipulation, Gene Cloning & Recombinant Technology",
    description:
      "DNA extraction purification & quantification, Restriction enzymes & DNA ligase, Plasmids & vectors for gene transfer, PCR amplification & gel electrophoresis, Creating recombinant DNA in labsearn structure, responsive layout, flexbox, grid, media queries, animations.",
  },
  {
    title: "Microbial Genetics & Transformation Techniques",
    description:
      "Bacterial DNA plasmids & gene transfer, Transformation transduction & conjugation, Using E. coli as a model organism, Antibiotic selection & screening, Hands-on microbial gene modification",
  },
  {
    title: "CRISPR-Cas9 Genome Editing & Modern Gene Tools",
    description:
      "Understanding CRISPR mechanisms, Guide RNA design & Cas9 function, Precision gene editing & knockout/knock-in, Ethical medical & biological implications, Real applications in gene therapy & disease correction",
  },
  {
    title: "Plant Genetic Engineering & Agricultural Biotechnology",
    description:
      "Agrobacterium-mediated gene transfer, Creating GM crops: pest-resistant drought-tolerant varieties, Plant tissue culture & regeneration, Marker genes & selection, Applications in sustainable agriculture",
  },
  {
    title: "Database - MongoDBAnimal Genetics, Transgenics & Biomedical Applications",
    description:
      "Gene modification in animals, Creating transgenic mice & model organisms, Cloning basics (somatic cell nuclear transfer), Applications in disease research & pharmaceuticals, Ethical considerations in animal genetics",
  },
  {
    title: "Bioinformatics, Genomics & Computational Tools",
    description:
      "DNA & protein sequence analysis, BLAST NCBI UniProt genome databases, Gene prediction & functional annotation, DNA alignment phylogenetics & evolutionary analysis, Intro to AI-driven genomics",
  },
  {
    title: "Deployment & CI/Gene Therapy, Medical Biotechnology & Clinical Applications",
    description:
      "gene therapy & how it works, Viral vectors (AAV lentivirus), Treatment strategies for genetic disorders, Personalized medicine & pharmacogenomics, Safety regulations & FDA/ICMR guidelines",
  },
  {
    title: "Laboratory Techniques, Safety & Ethical Guidelines",
    description:
      "Pipetting centrifugation culturing basics, Sterilization & aseptic techniques, Biosafety levels (BSL) & lab protocols, Ethical legal & social implications of genetic engineering, Genome editing boundaries & international laws",
  },
  {
    title: "Capstone Genetic Engineering Project & Career Roadmap",
    description:
      "Designing a complete genetic engineering experiment, Lab documentation & scientific reporting, Building a biotechnology/GE portfolio, Resume & LinkedIn optimization for biotech roles, Interview prep for Genetic Engineer Research Associate Bioinformatics Analyst",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
